module.exports = __webpack_public_path__ + "media/get-money-from-sb.b3f2020d.wav";